import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, setStoredToken } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // CRITICAL: Persist the session token so we can send it as Bearer when
        // 3rd-party cookies are blocked (Chrome default). Backend now returns it.
        if (data?.session_token) setStoredToken(data.session_token);
        await refresh();
      } catch (e) {
        console.error("Auth callback failed:", e);
      } finally {
        navigate("/history", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <main className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-6 h-6 animate-spin text-zinc-400 mx-auto mb-3" />
        <p className="overline">Signing you in...</p>
      </div>
    </main>
  );
}
